import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppIdCacheKeys: AllRouteEndpoints[] = ["/apps/app_group", "/apps/app_groups"];
